import { ErrorBoundary, withSentryReactRouterV6Routing } from '@sentry/react'
import TagManager from 'react-gtm-module'
import { createBrowserRouter, Route, RouterProvider, Routes } from 'react-router-dom'

import { AppLayout } from '@layouts/app_layout'
import { OfferLayout } from '@layouts/offer_layout'
import { PageLayout } from '@layouts/page_layout'
import { ProfileLayout } from '@layouts/profile_layout'
import { useLocationContext } from '@providers/location'
import { NotFound } from '@views/not_found'
import { routesBySection } from './routes_definitions'
import type { TRouteConfig } from './types'

const SentryRoutes = withSentryReactRouterV6Routing(Routes)

const sectionLayoutMap = {
  initial: null,
  pages: <PageLayout />,
  offers: <OfferLayout />,
  profile: <ProfileLayout />,
  noHeaderPages: null,
} as GenericSimpleBag

const RouteConfig = () => {
  const { location } = useLocationContext()

  if (location) {
    TagManager.dataLayer({
      dataLayer: {
        location: {
          name: location?.name,
        },
      },
    })
  }

  const renderRoute = (routeConfig: TRouteConfig) => {
    const Element = routeConfig.component
    return <Route key={routeConfig.uid} element={<Element />} path={routeConfig.path} />
  }

  return (
    <ErrorBoundary fallback={<NotFound />}>
      <SentryRoutes>
        {Object.keys(routesBySection).map((section) => (
          <Route key={section} element={<AppLayout routeConfigs={routesBySection[section]} />}>
            <Route element={sectionLayoutMap[section]}>{routesBySection[section].map(renderRoute)}</Route>
            <Route path="*" element={<NotFound />} />
          </Route>
        ))}
      </SentryRoutes>
    </ErrorBoundary>
  )
}

const router = createBrowserRouter([{ path: '*', Component: RouteConfig }])

export const AppRoutes = () => {
  return <RouterProvider router={router} />
}
